import { render, staticRenderFns } from "./EModalSelecionarGestao.vue?vue&type=template&id=f97b2a06&scoped=true"
import script from "./EModalSelecionarGestao.vue?vue&type=script&lang=js"
export * from "./EModalSelecionarGestao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97b2a06",
  null
  
)

export default component.exports